<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/scss/size";

* {
    box-sizing: border-box;
}

#app {
  font-family: 'Roboto', sans-serif;
  max-width: $max-page-width;
  margin: 0 auto;
}

a {
  color: #4E9D59;
  text-decoration: none;
}

h1, h2, p {
  color: #2d402f;
}

hr {
  border: 0;
  border-bottom: 2px solid #DEDEDE;
  width: 100%;
  margin-bottom: 2em;
}

button, .button {
  display: inline-block;
  font-size: 1em;
  cursor: pointer;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.8);
  padding: 1em 1.5em;
  text-align: center;

  &.primary {
    background: #92D59B;

    &:disabled {
      background: #8d8d8d;
    }
  }
}

.with-bottom-margin {
  margin-bottom: 1.5em;
}


.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

</style>
